module.exports = __webpack_public_path__ + "img/favicon.b0601fd7.ico";